import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import { toCamel } from "snake-camel";
import EmptyGraphMessage from "@/assets/common/AggregationFunction/EmptyGraphMessage/EmptyGraphMessage.vue";
import ProducerInvitationModal from "@/assets/common/Modal/ProducerInvitationModal/ProducerInvitationModal.vue";
import ProducerListNotificationModal from "@/assets/common/Modal/ProducerListNotificationModal/ProducerListNotificationModal.vue";
import ProducerRegistrationModal from "@/assets/common/Modal/ProducerRegistrationModal/ProducerRegistrationModal.vue";
import ProducerImportModal from "@/assets/common/Modal/ProducerImportModal/ProducerImportModal.vue";
import CultivationHistoryRegisterModal from '@/assets/common/Modal/CultivationHistoryRegisterModal/CultivationHistoryRegisterModal.vue';
import { CsvDownload } from "@/types/APIResponse";
import { LoginUser } from "@/types/Component";

type Producers = {
    pdId: string;
    pdName: string;
    dateOfBirth: string;
};

type ProducersGet = {
    producers: Producers[];
};

@Component({
    components: {
        EmptyGraphMessage,
        ProducerInvitationModal,
        ProducerListNotificationModal,
        ProducerRegistrationModal,
        ProducerImportModal,
        CultivationHistoryRegisterModal,
    },
})
export default class ProducerList extends Vue {
    private isOpen = false;
    screen = "PRODUCERLIST";
    private list: any | null = null;
    private title = "生産者一覧";
    baseUrl = "/producers_list";
    producerInviteUrl = "/producer_invite";
    private producersUrl = "/producers";
    private comBaseUrlCommit = "/committees";
    selectScreenManagement = "/graphScreenManagement";
    private producerList = [] as any[];
    private producerNumber = "";
    private mailAddress = "";
    private selectedCommitteeName = "";
    private isDeletedProducerInvite = false;
    cvmode: string | 'new' | 'edit' = 'new';
    cvId: string | null = null;

    private committees = [] as any[];
    private producers = [] as any[];

    private isSpinnerLoading = false;
    private sortOrder = true;
    private isRefresh = false;
    private isLoading = false;
    includeHiddenFlag = false;
    searchQueryProducers = "";
    isProducerDropdownVisible = false;
    isReadOnly = false;
    alertFlag = false;
    private selectedCommitteeId: string | null = null;
    selectedProducerNotification = "";
    selectedProducerName = "";

    showProducerInviteModal = false;
    showProducerListNotificationModal = false;
    private inviteBtnDisable = false;
    private selectedItems = [] as string[];
    private invitationId = [] as string[];
    private localDeleteParams = [] as string[];
    private cgDeleteParams = [] as string[];
    private showProducerRegistrationModal = false;
    private showProducerImportModal = false;
    private selectedProducerId = "";
    private mode = "";
    private selctedmail = "";
    private isNoyakuNavi = false;
    private disableDeleteBtn = true;
    private producerCancelBtn = true;
    private deleteParams = [] as string[];
    invitationDetails: any;
    private showRead = false;
    showCvhModal = false;
    expandedAlertRows = [] as number[];
    producerTenantTotalCount = ""


    get isAdmin(): boolean {
        return (
            this.loginUser.role.find((r: string) => {
                return r === "ADMIN";
            }) !== undefined
        );
    }

    get loginUser(): LoginUser {
        return this.$store.getters.loginUser;
    }

    get isPesticidePlan(): boolean {
        return this.loginUser.isPesticidePlan;
    }

    get pesticidePlanProducer(): boolean {
        return this.loginUser.pesticidePlanProducer;
    }

    get producerListModalOpen():boolean{
        return(
            this.showProducerInviteModal ||
            this.showProducerListNotificationModal ||
            this.showProducerRegistrationModal ||
            this.showProducerImportModal ||
            this.showCvhModal
        )
    }

    @Watch('producerListModalOpen')
    onAnyModalVisibilityChanged(val: boolean) {
        this.$root.$emit('header-inert', val);
    }

    private created() {
        this.isSpinnerLoading = true;
        this.getCommittees();
        this.getProducers();
        this.getProducerList();
        const loginUserRole = this.$store.getters.loginUser.role;
        if (
            loginUserRole.includes("ADMIN") ||
            loginUserRole.includes("CONTRACT_ADMIN") || 
            loginUserRole.includes("USER") 
        ) {
            this.inviteBtnDisable = false;
        } else {
            this.inviteBtnDisable = true;
        }
    }

    openProducerInviteModal(): void {
        this.showProducerInviteModal = true;
        this.isOpen = false;
    }

    producerImport(): void {
        this.showProducerImportModal = true;
        this.isOpen = false;
    }

    openProducerNotificationModal(producerList: any): void {
        this.selectedProducerNotification = producerList.pdId;
        this.selectedProducerName = producerList.pdName;
        this.showProducerListNotificationModal = true;
        this.isOpen = false;
        if (producerList.allNotificationRead == 1) {
            this.showRead = true;
        }
    }

    async getProducerList() {
        this.isSpinnerLoading = true;
        await this.$apiClient
            .doRequest("get", `${this.baseUrl}?is_deleted=${this.isDeletedProducerInvite}`)
            .then((res) => {
                const values = res.producerList
                .map((item: any) => item.producerTenantCount)
                .filter((v: any) => v !== null && v !== undefined);
                this.producerTenantTotalCount = values.length === 0 ? '---' : values.reduce((sum: number, v: any) => sum + Number(v), 0);
                setTimeout(() => {
                    this.isSpinnerLoading = false;
                }, 500);
                this.producerList = res.producerList.map((item:any) => {
                if (item.alertInfo && item.cultivationIds) {
                    const alerts = item.alertInfo.split("::").map((s:any) => s.trim());
                    const ids = item.cultivationIds.split("::").map((s:any) => s.trim());

                    item.alertsCombined = ids.map((id:any, index:any) => ({
                        id,
                        message: alerts[index] || null
                    }));
                } else {
                    item.alertsCombined = [];
                }
                return item;
              });
                if (res.selectedItems != null) {
                    this.producerNumber = res.selectedItems.pdNum || "";
                    this.searchQueryProducers = res.selectedItems.pdName || "";
                    this.mailAddress = res.selectedItems.mailAddress || "";
                    this.selectedCommitteeId = res.selectedItems.committeeId;
                    this.includeHiddenFlag = res.selectedItems.includeHiddenFlag;
                }
            });
    }

    refreshTable() {
        this.producerList = [];
        this.isSpinnerLoading = true;
        this.getProducerList();
        this.getProducers();
    }

    handleSearch(flag = true) {
        this.selectedCommitteeName = this.committees.find(
            (item) => item.id == this.selectedCommitteeId
        )?.name;
        const errmsg: string[] = [];
        if (this.producerNumber.length > 4) {
            errmsg.push(
                `生産者番号は4桁以内で入力してください（現在は${this.producerNumber.length}桁）`
            );
        }
        if (this.searchQueryProducers.trim().length > 100) {
            errmsg.push(
                `氏名は100文字以内で入力してください（現在は${
                    this.searchQueryProducers.trim().length
                }文字）`
            );
        }
        if (this.mailAddress.trim().length > 255) {
            errmsg.push(
                `メールアドレスは255文字以内で入力してください（現在は${
                    this.mailAddress.trim().length
                }文字）`
            );
        }

        if (errmsg.length > 0) {
            window.alert(errmsg.join("\n"));
            return false;
        }
        const params = {
            pdNum: this.producerNumber === "" ? null : this.producerNumber,
            pdName:
                this.searchQueryProducers.trim() === ""
                    ? null
                    : this.searchQueryProducers.trim(),
            mail_address:
                this.mailAddress.trim() === "" ? null : this.mailAddress.trim(),
            committee_id: this.selectedCommitteeId,
            screenName: this.screen,
            includeHiddenFlag: this.includeHiddenFlag,
        };
        this.$apiClient
            .doRequest("post", `${this.selectScreenManagement}`, params)
            .then((res) => {
                if (flag) {
                    this.refreshTable();
                }
            })
            .catch((error) => {
                this.$toasted.error("データの取得に失敗しました。");
            });
    }

    async getCommittees() {
        await this.$apiClient
            .doRequest("get", `/committees?with_hidden=true`)
            .then((res) => {
                this.committees = res.committees;
            });
    }

    async getProducers() {
        await this.$apiClient
            .doRequest("get", `${this.producersUrl}`)
            .then((res) => {
                this.producers = (toCamel(res) as ProducersGet)
                    .producers as Producers[];
            })
            .catch((error) => {
                console.error("Failed to fetch producers:", error);
            });
    }

    get filteredProducers() {
        const producers = this.includeHiddenFlag
            ? this.producers
            : this.producers.filter((p) => !p.isHidden);
        if (!this.searchQueryProducers) {
            return producers;
        }
        const filtered = producers.filter((producer) =>
            producer.pdName.includes(this.searchQueryProducers)
        );
        return filtered;
    }

    get filteredCommittees() {
        const committees = this.includeHiddenFlag
        ? this.committees
        : this.committees.filter(c =>!c.is_hidden);
      
        return committees;
    }

    csvDownload() {
        this.$apiClient
            .getRequest(
                `${this.baseUrl}/csv_export?producer_name=${
                    this.searchQueryProducers
                }&pd_num=${this.producerNumber}&mail_address=${
                    this.mailAddress
                }&committee_name=${
                    this.selectedCommitteeName ? this.selectedCommitteeName : ""
                }&is_deleted=${this.isDeletedProducerInvite}`
            )
            .then((res: CsvDownload) => {
                this.$apiClient.csvDownload(res);
            })
            .catch((error) => {
                this.$toasted.error("データの取得に失敗しました。");
            });
    }

    //氏名
    clearSearchQueryProducers() {
        this.searchQueryProducers = "";
        this.handleSearch();
    }

    selectProducers(producers: any) {
        this.searchQueryProducers = producers.pdName;
        this.isProducerDropdownVisible = false;
        this.handleSearch();
    }

    hideProducersDropdown() {
        this.isProducerDropdownVisible = false;
    }
    filterProducersDropdown() {
        this.isProducerDropdownVisible = true;
    }

    private dateFormat(date: Date) {
        if (date) {
            const year = new Date(date).getFullYear();
            const month = ("0" + (new Date(date).getMonth() + 1)).slice(-2);
            const day = ("0" + new Date(date).getDate()).slice(-2);
            return year + "/" + month + "/" + day;
        }
        return "-";
    }

    private cancelProducerInvite() {
        const params = this.selectedItems;
        this.producerList.map((item: any) => {
            if (
                item.errorMessage == null &&
                this.invitationId != null &&
                params.includes(item.producerInvitationId)
            ) {
                this.cgDeleteParams.push(item.invitationId);
            }
            if (params.includes(item.producerInvitationId)) {
                this.localDeleteParams.push(item.producerInvitationId);
            }
        });

        if (this.cgDeleteParams.length) {
            this.deleteProducerInvite();
        } else if (this.localDeleteParams.length) {
            this.deleteProducerInvite();
        }
    }

    private deleteProducerInvite() {
        const params = this.localDeleteParams;
        this.$apiClient
            .doRequest("delete", `${this.producerInviteUrl}`, params)
            .then((res) => {
                this.localDeleteParams = [];
                this.getProducerList();
            })
            .catch((error) => console.log(error));
    }

    openProducerRegistrationModal(
        producerId = "",
        mode = "",
        mailaddress = ""
    ) {
        this.showProducerRegistrationModal = true;
        this.selectedProducerId = producerId;
        this.selctedmail = mailaddress;
        this.isNoyakuNavi = true;
    }

    private deleteProducer() {
        const confirm = window.confirm("削除しますか？");
        this.isLoading = true;
        const tenantId = this.$store.getters.tenantId;

        const idsToDelete = Array.isArray(this.deleteParams)
            ? [...this.deleteParams]
            : [];

        if (confirm) {
            idsToDelete.forEach((id: string) => {
                this.$apiClient
                    .doRequest(
                        "put",
                        `${this.producersUrl}/${id}/delete?tenant_id=${tenantId}`
                    )
                    .then(() => {
                        this.$toasted.success("削除しました。");
                        this.refreshTable();
                        this.selectedItems = [];
                        this.disableDeleteBtn = true;
                    })
                    .catch(() => {
                        this.$toasted.error("削除に失敗しました。");
                    });
            });
        } else {
            this.$toasted.success("削除がキャンセルされました。");
            this.isLoading = false;
        }
    }

    private onCheckboxChange() {
        const selectedProducers = this.producerList.filter((producer: any) =>
            this.selectedItems.includes(
                producer.producerInvitationId ?? producer.pdId
            )
        );

        if (selectedProducers.length === 0) {
            this.producerCancelBtn = true;
            this.disableDeleteBtn = true;
            this.deleteParams = [];
            return;
        }

        this.producerCancelBtn = selectedProducers.some(
            (p) => p.joinDate != null
        );
        this.disableDeleteBtn = !selectedProducers.every(
            (p) => p.joinDate != null
        );
        this.deleteParams = selectedProducers
            .filter((p) => p.joinDate != null)
            .map((p) => p.pdId);
    }

    limitedNotifications(message: any) {
        const items = message.split("::");
        return items.slice(0, 5);
    }
    hasMoreNotifications(message: any) {
        const items = message.split("::");
        return items.length > 5;
    }

    changeExpiredate(expires: string) {
        const timestamp = Number(expires);
        if (isNaN(timestamp)) {
            console.error("Invalid timestamp:", expires);
            return "Invalid date";
        }
        const expireDate = new Date(timestamp).toLocaleDateString("ja-JP");
        return expireDate;
    }

    isInviteExpired(producer: any): boolean {
        if (!producer?.expiresDate) return false;
        const expires = new Date(Number(producer.expiresDate));
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        return (
            !producer.joinDate && !isNaN(expires.getTime()) && expires < today
        );
    }

    handleAlertClick(id:any){
        this.cvmode = 'edit';
        this.cvId = id;
        this.showCvhModal = true;
    }

    toggleAlertExpand(rowIndex: number) {
        if (this.expandedAlertRows.includes(rowIndex)) {
            this.expandedAlertRows = this.expandedAlertRows.filter(i => i !== rowIndex);
        } else {
            this.expandedAlertRows.push(rowIndex);
        }
    }
}